import React, { Fragment } from "react";
import { List, Datagrid, Edit, Create, SimpleForm, TextField, SearchInput, EditButton, TextInput, BooleanField, TranslatableFields, BooleanInput, CreateButton, TopToolbar } from 'react-admin';
import ThreeDRotationIcon from '@material-ui/icons/ThreeDRotation';
import OrderingField from '../Fields/Ordering.field';
import { Route, useHistory } from 'react-router';
import { Drawer, makeStyles } from '@material-ui/core';
import { required } from 'react-admin';
import { translations } from '../../i18n/i18n';
import ConfigGeneral from '../../config/general';

const useStyles = makeStyles({
	drawerContent: {
		width: 500
	}
});

const filters = [
    <SearchInput source="translations.name" alwaysOn />,
];

const ListActions = ({ basePath }) => (
	<TopToolbar>
		<CreateButton basePath={basePath} />
	</TopToolbar>
);

const ModelTypeIcon = ThreeDRotationIcon;
const ModelTypeList = (props) => {
	const classes = useStyles();
	const history = useHistory();
	const handleClose = () => history.push('/'+props.resource);

	return <Fragment>
		<List actions={<ListActions />} filters={filters} perPage={25} sort={{ field: 'ordering', order: 'ASC' }} {...props}>
			<Datagrid>
				<TextField source="id" />
				<TextField source="name_display" sortable={false} />
				<BooleanField source="state" looseValue />
				<OrderingField source="ordering" />
				<EditButton basePath="/modeltypes" />
			</Datagrid>
		</List>

		<Route path={'/'+props.resource+'/create'} exact>
			{({ match }) => (
				<Drawer open={!!match} anchor="right" onClose={handleClose}>
					<ModelTypeCreate className={classes.drawerContent} onCancel={handleClose} {...props} />
				</Drawer>
			)}
		</Route>

		<Route path={'/'+props.resource+'/:id'}>
			{({ match }) => {
				const isMatch = (match && match.params && match.params.id !== 'create');

				return (
					<Drawer open={!!isMatch} anchor="right" onClose={handleClose}>
						{isMatch ? (
							<ModelTypeEdit
								className={classes.drawerContent}
								id={isMatch ? match.params.id : null}
								onCancel={handleClose}
								{...props}
							/>
						) : (
							<div className={classes.drawerContent} />
						)}
					</Drawer>
				);
			}}
		</Route>
	</Fragment>
};

const ModelTypeEdit = (props) => (
    <Edit title=" " undoable={false} {...props}>
        <SimpleForm>
			<TranslatableFields locales={ConfigGeneral.locales.map(locale => locale.code)}>
				<TextInput source="name" fullWidth validate={[required()]} />
			</TranslatableFields>
            <BooleanInput source="state" />
        </SimpleForm>
    </Edit>
);

const ModelTypeCreate = (props) => (
    <Create title=" " undoable={false} {...props}>
        <SimpleForm>
			<TranslatableFields locales={ConfigGeneral.locales.map(locale => locale.code)}>
				<TextInput source="name" fullWidth validate={[required()]} />
			</TranslatableFields>
            <BooleanInput source="state" />
        </SimpleForm>
    </Create>
);

let exports = {
	list: ModelTypeList,
	icon: ModelTypeIcon,
};
export default exports;